<template>
  <v-container>
    <v-row>
      <v-col cols="10" offset="1">
        <h2 class="title mb-3">執筆記事一覧</h2>
        <v-tabs v-model="orderStatusIndex" class="my-5" color="primary">
          <v-tab @click="switchTab('10')"> 執筆中 </v-tab>
          <v-tab @click="switchTab('30')"> 検収中 </v-tab>
          <v-tab @click="switchTab('40')"> 完了 </v-tab>
        </v-tabs>

        <v-layout row class="py-3">
          <v-text-field
            v-model="searchQuery.post_title_cont"
            label="タイトルで絞り込む"
            style="max-width: 400px"
            class="ml-5"
            clearable
            required
          />
          <v-btn
            color="primary"
            dark
            tile
            outlined
            class="ml-4 mt-3"
            @click="searchOrders"
          >
            検索
          </v-btn>
        </v-layout>

        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center" style="width: 80px">記事ID</th>
              <th class="text-center" style="width: 80px">発注ID</th>
              <th class="text-center" style="width: 80px">差し戻し</th>
              <th class="text-left">タイトル</th>
              <th class="text-left">ライター校了日</th>
              <th class="text-left">最終更新日</th>
              <th class="text-left">公開日</th>
              <th />
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td class="text-center">
                {{ order.postId }}
              </td>
              <td class="text-center">
                {{ order.id }}
              </td>
              <td class="text-center">
                <v-icon v-if="order.isRemanded" color="error" small>
                  mdi-check-circle
                </v-icon>
              </td>
              <td class="py-2">
                {{ order.post.title }}
              </td>
              <td>
                {{ order.completedAt | moment }}
              </td>
              <td>
                {{ order.post.updatedAt | moment }}
              </td>
              <td>
                {{ order.post.releasedOn | moment }}
              </td>
              <td class="text-center">
                <router-link
                  class="editLink"
                  :to="{
                      name: 'writerPostEdit',
                      params: { id: order.postId },
                    }"
                  target="_blank"
                >
                  <v-btn class="ma-2" tile outlined small color="primary">
                    <v-icon left small> mdi-pencil </v-icon>
                    編集
                  </v-btn>
                </router-link>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'
import moment from 'moment'
import headUtilsMixin from '@/mixins/head_utils'
import orderUtils from '@/mixins/order_utils'

export default {
  components: {
    InfiniteLoading
  },
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [headUtilsMixin, orderUtils],
  data: () => {
    return {
      pageTitle: '執筆記事一覧',
      page: 1,
      searchQuery: {
        status_eq: '10',
        post_title_cont: null
      },
      orders: [],
      infiniteId: +new Date(),
      orderStatusIndex: 0
    }
  },
  methods: {
    searchOrders () {
      this.page = 1
      this.orders = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      axios
        .get('/api/orders', {
          params: {
            page: this.page,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          const activeOrders = fetchedOrders.filter(order => !this.isDeadOrder(order))
          if (activeOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(activeOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    switchTab (orderStatus) {
      this.searchQuery.status_eq = orderStatus
      this.searchOrders()
    }
  }
}
</script>

<style scoped></style>
